@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.template

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.feature.domain.repository.TemplateRepository
import kotlinx.coroutines.flow.Flow

actual class GetSimpleListTemplateUseCaseImpl actual constructor(val templateRepository: TemplateRepository) :
    GetSimpleListTemplateUseCase {
    actual override operator fun invoke(): Flow<FlowResult<List<SelectionModel>>> {
        return templateRepository.getSimpleTemplates()
    }
}
